import { createFileRoute } from '@tanstack/react-router'
import { allProducts, settingsNavFor } from '@bloo-team/core-shell'

/**
 * Every Settings path with no screen behind it.
 *
 * Three sections are listed in the nav and not built — Components, SMTP,
 * Usage & Licensing (docs/settings-requirements.md §1). Without this they were
 * live links into the router's bare not-found, which reads as a broken console
 * rather than as unfinished work. The nav marks them "Soon"; this says what
 * "Soon" is waiting on.
 *
 * Sections 7 and 8 captured ZERO calls on the live sweep, so neither may be
 * built against an assumed contract (S6) — the block is a missing contract,
 * not missing time, and the page says so rather than promising a date.
 */
function SettingsNotBuilt() {
  const { _splat } = Route.useParams()
  // Registered (not entitled) composition: naming a not-built section is
  // harmless, and an unentitled product's own routes never land here.
  const section = settingsNavFor(allProducts()).find(
    (item) => item.to === `/settings/${(_splat ?? '').split('/')[0]}`,
  )

  return (
    <div className="app-stack app-stack-wide">
      <section className="hud-panel sy-card" aria-label={section ? section.title : 'Unknown section'}>
        <span className="hud-eyebrow">{section ? 'Not built yet' : 'No such section'}</span>
        {section ? (
          <>
            <p className="bloo-body">
              <strong>{section.title}</strong> is planned but has no screen yet.
            </p>
            <p className="sy-help">
              Its legacy endpoints are known, but a live sweep of the old console never reached
              them — so the contract is a guess, and a guess is not something to build a write
              surface on. docs/settings-requirements.md carries what a probe has to answer first.
            </p>
          </>
        ) : (
          <p className="sy-help">
            No Settings section lives at this address. Pick one from the nav.
          </p>
        )}
      </section>
    </div>
  )
}

export const Route = createFileRoute('/$clusterId/$scopeId/settings/$')({
  component: SettingsNotBuilt,
})
